import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { StreamAction } from '../stream.action';

export const startStreamProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    StreamAction.create.started,
    StreamAction.update.started,
    StreamAction.remove.started,
  ),
  mergeMap(() => {
    return [
      StreamAction.processing.started(),
    ];
  }),
);
